// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__mLMnQ","validationTips":"StatementDescriptor_validationTips__3PrZ2"};